import React from "react";
import Banner from "../../Components/Banner";
import Footer from "../../Components/Footer";
import { motion } from "framer-motion";
import CareersInitialSection from "./Sections/CareersInitial/CareersInitial";
import CareersFounderMessageSection from "./Sections/CareersFounderMessage/CareersFounderMessage";
import WorkedOnSection from "../../Components/WorkedOnSection";
import Header from "../../Components/Header";
import GradientGlowDivider from "../../Components/GradientGlowDivider";
import CareersRoleSection from "./Sections/CareersRole/CareersRole";

const CareersPage = () => {
  return (
    <motion.div
      className="flex flex-col"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div className="sticky md:static top-0 md:top-auto z-50 md:z-0 bg-app-background md:bg-transparent">
        <Header />
        <div className="w-[90%] mx-auto hidden md:block">
          <GradientGlowDivider />
        </div>
      </div>
      <CareersInitialSection />
      <CareersFounderMessageSection />
      <CareersRoleSection />
      <Banner
        title="Step into the future of AI"
        hideSubtitleInWeb={true}
        subtitle="Let's Talk!"
        description="Kickstart your journey toward an exciting career today!"
      />
      <WorkedOnSection
        title="The impact we create"
        className="!pb-0 md:pb-40"
        showExploreMore={true}
      />
      <Footer className="mt-[0%]" />
    </motion.div>
  );
};

export default CareersPage;
